import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/AuthContext";
import { LangProvider } from "@/lib/i18n";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import DemoTourBar from "@/components/DemoTourBar";
import HomePage from "@/pages/HomePage";
import ExplorePage from "@/pages/ExplorePage";
import MatchmakerPage from "@/pages/MatchmakerPage";
import SolutionPage from "@/pages/SolutionPage";
import OrganizerPage from "@/pages/OrganizerPage";
import ProfilePage from "@/pages/ProfilePage";
import PublicReportPage from "@/pages/PublicReportPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App bg-slate-50 text-slate-900">
      <LangProvider>
      <AuthProvider>
        <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="min-h-[70vh] pb-20">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/jelajahi" element={<ExplorePage />} />
            <Route path="/matchmaker" element={<MatchmakerPage />} />
            <Route path="/solusi" element={<SolutionPage />} />
            <Route path="/organizer" element={<OrganizerPage />} />
            <Route path="/profil" element={<ProfilePage />} />
            <Route path="/laporan-publik" element={<PublicReportPage />} />
          </Routes>
        </main>
        <Footer />
        <DemoTourBar />
        <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
